// extracted by mini-css-extract-plugin
export default {"option":"OptionCard_option__5SeD3","selected":"OptionCard_selected__nYQrH","disabled":"OptionCard_disabled__165qe"};